// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SteelTable_tableContainer__09l89 {
  width: 100%;
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.SteelTable_tableWrapper__Co6tD {
  width: 100%;
  max-width: 1110px;
  overflow-x: auto;
  border-radius: var(--border-radius-lg);
}

.SteelTable_tableTitle__r712K {
  color: #fff;
  margin-bottom: 20px;
  font-size: var(--font-size-lg);
  font-weight: bold;
}

.SteelTable_steelTable__9\\+7nu {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  border-radius: var(--border-radius-lg);
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.SteelTable_steelTable__9\\+7nu th {
  background-color: var(--color-accent-light);
  padding: 16px 20px;
  color: #fff;
  border: 1px solid var(--color-background);
  font-weight: bold;
  font-size: var(--font-size-lg);
  text-align: center;
}

.SteelTable_steelTable__9\\+7nu td {
  padding: 12px 20px;
  border: 1px solid var(--color-background);
  font-size: var(--font-size-md);
  color: var(--color-background);
  text-align: center;
  white-space: nowrap;
}

.SteelTable_steelTable__9\\+7nu tr:nth-child(even) {
  background-color: var(--color-accent-super-light);
}

.SteelTable_steelTable__9\\+7nu tr:hover {
  background-color: var(--color-accent-super-light-pressed);
} `, "",{"version":3,"sources":["webpack://./src/components/Tables/SteelTable/SteelTable.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,sCAAsC;EACtC,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,8BAA8B;EAC9B,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,yDAAyD;AAC3D","sourcesContent":[".tableContainer {\n  width: 100%;\n  margin: 20px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.tableWrapper {\n  width: 100%;\n  max-width: 1110px;\n  overflow-x: auto;\n  border-radius: var(--border-radius-lg);\n}\n\n.tableTitle {\n  color: #fff;\n  margin-bottom: 20px;\n  font-size: var(--font-size-lg);\n  font-weight: bold;\n}\n\n.steelTable {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: #fff;\n  border-radius: var(--border-radius-lg);\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.steelTable th {\n  background-color: var(--color-accent-light);\n  padding: 16px 20px;\n  color: #fff;\n  border: 1px solid var(--color-background);\n  font-weight: bold;\n  font-size: var(--font-size-lg);\n  text-align: center;\n}\n\n.steelTable td {\n  padding: 12px 20px;\n  border: 1px solid var(--color-background);\n  font-size: var(--font-size-md);\n  color: var(--color-background);\n  text-align: center;\n  white-space: nowrap;\n}\n\n.steelTable tr:nth-child(even) {\n  background-color: var(--color-accent-super-light);\n}\n\n.steelTable tr:hover {\n  background-color: var(--color-accent-super-light-pressed);\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": `SteelTable_tableContainer__09l89`,
	"tableWrapper": `SteelTable_tableWrapper__Co6tD`,
	"tableTitle": `SteelTable_tableTitle__r712K`,
	"steelTable": `SteelTable_steelTable__9+7nu`
};
export default ___CSS_LOADER_EXPORT___;
